export default "/static/azenta_perception_hd_tiny.png";